import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateLimitSchema } from '@app/models/products';
import Api from '@app/services/api';

interface IProps {
  data: CreateLimitSchema;
  catalogUid: string;
}

export const useCreateCatalogLimitQuery = () => {
  const client = useQueryClient();
  const catalogsT = useTranslation(NSKeys.catalogs);

  return useMutation({
    mutationFn: async ({ data, catalogUid }: IProps) => {
      await Api.products.postCatalogLimit(catalogUid, data);
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getCatalogLimits']);
      message.open({
        type: 'success',
        content: catalogsT.t('limits.toastCreateSuccess'),
      });
    },
  });
};
